import { EquipmentMaintenance } from 'types/EquipmentMaintenance';
import { GroupKeyPayload } from './types';
import { MaintenanceInterval } from 'types/MaintenanceInterval';

export function groupByInterval(
  schedules: EquipmentMaintenance[],
): Map<string, EquipmentMaintenance[]> {
  const filtered = schedules.filter(
    item => !!item.checkPoint && !!item.measures,
  );

  const grouped = new Map<string, EquipmentMaintenance[]>();

  for (const item of filtered) {
    if (item.firstCheckType && item.firstCheckValue != null) {
      const key = createGroupKey(
        item.firstCheckType,
        item.firstCheckValue,
        item.firstCheckType,
      );
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key)?.push(item);
    }
  }

  for (const item of filtered) {
    if (
      item.intervalType &&
      item.intervalValue != null &&
      item.displayIntervalType
    ) {
      const key = createGroupKey(
        item.intervalType,
        item.intervalValue,
        item.displayIntervalType,
      );
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key)?.push(item);
    }
  }

  return grouped;
}

export function createGroupKey(
  intervalType: string,
  intervalValue: number,
  displayIntervalType: string,
): string {
  return `${intervalType}__${intervalValue}__${displayIntervalType}`;
}

export function mapToInterval(
  grouped: Map<string, EquipmentMaintenance[]>,
): MaintenanceInterval[] {
  return Array.from(grouped.entries()).map(([keyStr, subList]) => {
    const key = parseGroupKey(keyStr);

    return {
      interval: constructIntervalString(
        key.displayIntervalType,
        key.intervalValue,
        key.intervalType,
      ),
      intervalType: key.intervalType,
      intervalValue: key.intervalValue,
      displayIntervalType: key.displayIntervalType.replace(
        ' X ',
        ` ${key.intervalValue} `,
      ),
      actions: subList.map(item => ({
        id: item.id,
        category: `${item.measures}`,
        value: `${item.checkPoint}`,
        isSelected: false,
      })),
      sortOrderPrimary: subList[0]?.sortOrder ?? 99,
      sortOrderSecondary: key.intervalValue,
    };
  });
}

export function parseGroupKey(keyStr: string): GroupKeyPayload {
  const [intervalType, valStr, display] = keyStr.split('__');
  return {
    intervalType,
    intervalValue: parseInt(valStr, 10),
    displayIntervalType: display,
  };
}

export function constructIntervalString(
  displayIntervalType: string,
  intervalValue: number,
  intervalType: string,
): string {
  if (intervalType === 'X Hours') {
    return `First ${intervalValue} Hours`;
  } else if (intervalType === 'X Months') {
    return `First ${intervalValue} Months`;
  } else if (intervalType === 'X Years') {
    return `First ${intervalValue} Years`;
  } else {
    return displayIntervalType.replace('X', String(intervalValue));
  }
}
